// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[1]!../../../../styles/colors.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ljh05LjEmWTrf_LEBv7c {
  margin: 36px 0 5px;
  padding: 5px 0;
}

.T5yqw7_ACcJIJiE5kAYs {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-primary"]};
  padding: 0;
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 16px;
  font-weight: normal;
}

._n3EZ9tIpxmGE89uz77f {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-orange"]};
  margin-right: 5px;
}

.PB3wnvvhlMWS80MgmpMA {
  font-size: 12px;
  line-height: 16px;
  font-weight: normal;
  margin: 5px 1px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-gray"]};
}

.b56_4ljNWlXt0PzDhsXY {
  padding: 10px 0;

  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  font-size: 20px;
  line-height: 27px;
}

.b56_4ljNWlXt0PzDhsXY:last-child {
  border-bottom: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/clients/settings/styles.module.css"],"names":[],"mappings":"AAGA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mDAAiB;EACjB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mDAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,mDAAc;AAChB;;AAEA;EACE,eAAe;;EAEf,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;;EAEnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["@value colors: \"../../../../styles/colors.module.css\";\n@value hc-primary, hc-gray, hc-orange from colors;\n\n.header {\n  margin: 36px 0 5px;\n  padding: 5px 0;\n}\n\n.notSet {\n  color: hc-primary;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: normal;\n}\n\n.notSetInfoIcon {\n  color: hc-orange;\n  margin-right: 5px;\n}\n\n.rowHeader {\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: normal;\n  margin: 5px 1px;\n  color: hc-gray;\n}\n\n.row {\n  padding: 10px 0;\n\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n\n  font-size: 20px;\n  line-height: 27px;\n}\n\n.row:last-child {\n  border-bottom: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../../../../styles/colors.module.css"`,
	"hc-primary": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-primary"]}`,
	"hcPrimary": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-primary"]}`,
	"hc-gray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-gray"]}`,
	"hcGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-gray"]}`,
	"hc-orange": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-orange"]}`,
	"hcOrange": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-orange"]}`,
	"header": `ljh05LjEmWTrf_LEBv7c`,
	"notSet": `T5yqw7_ACcJIJiE5kAYs`,
	"notSetInfoIcon": `_n3EZ9tIpxmGE89uz77f`,
	"rowHeader": `PB3wnvvhlMWS80MgmpMA`,
	"row": `b56_4ljNWlXt0PzDhsXY`
};
export default ___CSS_LOADER_EXPORT___;
